import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import useAuthStore from '../store/authStore';
import AuthLoading from './AuthLoading';

const ProtectedRoute = ({ children, allowedRoles = [], requireAdmin = false }) => {
  const { user, loading, isAdmin, hydrated, authInitialized, initializeAuth } = useAuthStore();

  // Initialize auth on component mount
  useEffect(() => {
    if (!authInitialized) {
      initializeAuth();
    }
  }, [authInitialized, initializeAuth]);

  // Check if authentication is still loading
  const authLoading = !hydrated || !authInitialized || loading;

  // Show loading spinner while auth is initializing
  if (authLoading) {
    return <AuthLoading />;
  }

  // Check if user is authenticated
  if (!user) {
    // For admin routes, redirect to admin login instead of regular login
    if (requireAdmin) {
      return <Navigate to="/admin-x8k3m5n7-9f1d9504-6b93-11e7-9696-600308a46260" />;
    }
    return <Navigate to="/login" />;
  }

  // SECURITY: For admin routes, require fresh server validation
  if (requireAdmin) {
    // Only redirect if we're not an admin
    if (!isAdmin) {
      return <Navigate to="/admin-x8k3m5n7-9f1d9504-6b93-11e7-9696-600308a46260" replace />;
    }
  }

  // Check if specific roles are required
  if (allowedRoles.length > 0) {
    const userRole = user.role || (isAdmin ? 'admin' : 'user');
    if (!allowedRoles.includes(userRole)) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  return children;
};

export default ProtectedRoute; 